import React, { useEffect, useState } from "react";
import allApi from "../../../api/allApi";
import { useLocation } from "react-router-dom";
import Loader from "../common/Loader";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { LineChart, Line, XAxis, YAxis, CartesianGrid } from "recharts";
import moment from "moment";
import { useLocalization } from "../localization/LocalizationContext";
import { useCallback } from "react";
import debounce from "lodash.debounce";
import { useNetwork } from "../common/networkContext";
import NmsTableSearch from "../common/NmsTableSearch";
import { NMS_CHART_COLORS, useDocumentTheme } from "../common/nmsChartTheme";

function App() {
  const location = useLocation();
  const { localizationStrings } = useLocalization();
  const { selectedNetworkId, selectedLocation } = useNetwork();
  const networkId = selectedNetworkId?.id ?? 6001;
  const theme = useDocumentTheme();
  const isDark = theme === "dark";
  const chartMuted = isDark ? "#94A3B8" : "#64748B";
  const chartBorder = isDark ? "#1E293B" : "#E2E8F0";
  const chartTitle = isDark ? "#F8FAFC" : "#0F172A";
  const [chartLoading, setChartLoading] = useState(true);
  // const queryParams = new URLSearchParams(location.search);
  //const severityLevel = queryParams.get("severityLevel");
  const [severityLevel, setSeverityLevel] = useState(null);
  const [totalDevices, setTotalDevices] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [deviceListings, setDeviceListings] = useState([]);
  const [filteredDevices, setFilteredDevices] = useState([]);
  const [originalListings, setOriginalListings] = useState([]);
  const [devicesPerPage] = useState(10);
  const [isSearchOpen, setIsSearchOpen] = useState({
    device_name: false,
    alarmType: false,
    severityLevel: false,
    is_acknowledged: false,
    is_autoclear: false,
    notification: false,
    alarm_behaviour: false,
    alarm_description: false,
    alarm_time: false,
    acked_time: false,
    cleared_time: false,
    is_read: false,
    event_name: false,
    device_ipv6: false,
    device_ip: false,
  });
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [show, setShow] = useState(false);
  const [alarmToDelete, setAlarmToDelete] = useState(null);
  const [faults, setFaults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [lastPage, setLastPage] = useState();
  const [sortOrder, setSortOrder] = useState({
    device_name: "asc",
    device_ip: "asc",
    severityLevel: "asc",
    alarm_behaviour: "asc",
    event_name: "asc",
    alarm_time: "asc",
    alarm_description: "asc",
  });
  const [alertsData, setAlertsData] = useState([]);
  const [selectedInterval, setSelectedInterval] = useState("1w");
  const [selectedCategory, setSelectedCategory] = useState("Miscellaneous");
  const [selectedSeverity, setSelectedSeverity] = useState("Critical");
  const [trendsLoading, settrendsLoading] = useState(true);
  const [trendsData, setTrendsData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [pageLinks, setPageLinks] = useState([]);
  const [license, setLicense] = useState("");
  const [searchTerms, setSearchTerms] = useState({});
  const [searchColumn, setSearchColumn] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [searchActive, setSearchActive] = useState(false);
  const [tableQuery, setTableQuery] = useState("");
  //const [networkId, setNetworkId] = useState(null);
  const [networkList, setNetworkList] = useState([]);

  const severityLevels = {
    Critical: 1,
    Major: 2,
    Minor: 3,
    Info: 4,
  };
  const categoryOptions = [
    { key: "Miscellaneous", label: localizationStrings?.miscellaneous },
    { key: "Threshold", label: localizationStrings?.threshold },
    {
      key: "Device Configuration",
      label: localizationStrings?.deviceConfiguration,
    },
    { key: "Device Status", label: localizationStrings?.deviceStatus },
  ];
  const severityOptions = [
    { key: "Critical", label: localizationStrings?.critical },
    { key: "Major", label: localizationStrings?.major },
    { key: "Minor", label: localizationStrings?.minor },
    { key: "Info", label: localizationStrings?.info },
  ];

  useEffect(() => {
    if (location.state && location.state.severityAlerts) {
      const severityAlerts = location.state.severityAlerts;
      setDeviceListings(severityAlerts);
      setFilteredDevices(severityAlerts);
      setTotalDevices(severityAlerts.length);
      setLoading(false);
    } else if (license,networkId) {
      fetchAlarmData(networkId);
      // fetchAlertsChartData();
    }
    if (license) {
      fetchAlertsChartData(networkId);
    }
  }, [location.state, license,networkId]);

  // useEffect(() => {
  //   fetchAlertsChartData();
  // }, []);
  // useEffect(() => {
  //   fetchAlarmData(currentPage);
  // }, [currentPage]);

  useEffect(() => {
    const storedLicense = localStorage.getItem("license");
    setLicense(storedLicense);
  }, []);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {
    if (networkId && license) {
      fetchAlarmData(networkId);
      fetchAlertsChartData(networkId);
      fetchAlertTrends(networkId);
    }
  }, [
    networkId,
    license,
    selectedInterval,
    selectedCategory,
    selectedSeverity,
  ]);

  const handleIntervalChange = (interval) => {
    setSelectedInterval(interval);
  };
  const handleCategoryChange = (categoryOptions) => {
    setSelectedCategory(categoryOptions);
  };
  const handleSeverityChange = (severityOptions) => {
    setSelectedSeverity(severityOptions);
  };

  // useEffect(() => {
  //   fetchNetworks();
  // }, []);

  // useEffect(() => {
  //   if (severityLevel && !location.state) {
  //     filterDevicesBySeverity(severityLevel, deviceListings);
  //   }
  // }, [severityLevel, deviceListings]);

  // const fetchNetworks = async () => {
  //   try {
  //     const api = new allApi();
  //     const response = await api.getRequest("api/network/allNetwork");
  //     if (
  //       response.status === "OK" &&
  //       Array.isArray(response.response) &&
  //       response.response.length > 0
  //     ) {
  //       setNetworkList(response.response);
  //       setNetworkId(response.response[0].network_id); // Set first network as default
  //     } else {
  //       setNetworkList([]);
  //     }
  //   } catch (error) {
  //     setNetworkList([]);
  //     console.error("Error fetching networks:", error);
  //   }
  // };

  const filterDevicesBySeverity = () => {
    if (severityLevel) {
      const filtered = deviceListings.filter(
        (alarm) => alarm.severityLevel === severityLevel
      );
      setFilteredDevices(filtered);
      setTotalDevices(filtered.length);
    } else {
      setFilteredDevices(deviceListings);
      setTotalDevices(deviceListings.length);
    }
  };

  const fetchAlarmData = async (networkId, page = 1) => {
    setLoading(true);
    try {
      const api = new allApi();
      const response = await api.getRequest(
        `api/alarms/all?page=${page}&size=${devicesPerPage}&alarmType=${license}&networkId=${networkId}`
      );
      if (response && response.items) {
        setDeviceListings(response.items);
        //setFilteredDevices(response.items); // Use this directly
        setOriginalListings(response.items);
        setTotalPages(response.totalPages || 1);
        setTotalDevices(response.totalItems || 0);
      } else {
        console.error("Invalid API response:", response);
        setDeviceListings([]);
        setFilteredDevices([]);
      }
    } catch (error) {
      console.error("Error fetching alarm data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (alarmId) => {
    try {
      const api = new allApi();
      await api.deleteRequest(`api/alarms/${alarmId}`);
      fetchAlarmData(networkId, currentPage);
      setAlarmToDelete(null);
    } catch (error) {
      console.error("Error deleting alarm:", error);
    }
  };

  const handleSelectAll = (isChecked) => {
    setSelectAllChecked(isChecked);
    if (isChecked) {
      setSelectedCheckboxes(filteredDevices.map((device) => device.alarm_id));
    } else {
      setSelectedCheckboxes([]);
    }
  };

  const handleSearchBox = (header) => {
    const updatedSearchOpen = {
      ...isSearchOpen,
      [header]: !isSearchOpen[header],
    };
    setIsSearchOpen(updatedSearchOpen);
  };

  const indexOfLastDevice = currentPage * devicesPerPage;
  const indexOfFirstDevice = indexOfLastDevice - devicesPerPage;
  const totalFilteredDevices = filteredDevices.length;
  const currentDevices = filteredDevices.slice(
    indexOfFirstDevice,
    indexOfLastDevice
  );

  const handleFilterDevice = () => {
    return filteredDevices.length
      ? filteredDevices.slice(
          (currentPage - 1) * devicesPerPage,
          currentPage * devicesPerPage
        )
      : [];
  };

  const handleSortChange = (field) => {
    // Toggle the sort order for the clicked field
    const newOrder = sortOrder[field] === "asc" ? "desc" : "asc";

    // Sort the gateways based on the field and order
    const sortedDevices = [...deviceListings].sort((a, b) => {
      // Handle undefined values gracefully
      const aValue = a[field] ? a[field].toString().toLowerCase() : "";
      const bValue = b[field] ? b[field].toString().toLowerCase() : "";

      if (newOrder === "asc") {
        return aValue.localeCompare(bValue);
      } else {
        return bValue.localeCompare(aValue);
      }
    });

    setDeviceListings(sortedDevices);
    setSortOrder((prevState) => ({
      ...prevState,
      [field]: newOrder, // Set the new sort order for the field
    }));
  };

  const successhandleClose = () => {
    setShow(false);
    setAlarmToDelete(null);
  };

  // const totalPages = Math.ceil(totalFilteredDevices / devicesPerPage);
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      if (searchActive) {
        debouncedSearch(nextPage, searchColumn, searchValue);
      } else {
        fetchAlarmData(networkId,nextPage);
      }
    }
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
    fetchAlarmData(networkId,1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      const prevPage = currentPage - 1;
      setCurrentPage(prevPage);
      fetchAlarmData(networkId,prevPage);
    }
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
    if (searchActive) {
      debouncedSearch(page, searchColumn, searchValue);
    } else {
      fetchAlarmData(networkId,page);
    }
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
    fetchAlarmData(networkId,totalPages);
  };

  const getPageNumbers = () => {
    const range = 1;
    const start = Math.max(1, currentPage - range);
    const end = Math.min(totalPages, currentPage + range);

    return [...Array(end - start + 1).keys()].map((i) => start + i);
  };

  const COLORS = NMS_CHART_COLORS;

  const fetchAlertsChartData = async (networkId) => {
    setChartLoading(true);
    try {
      const api = new allApi();
      const response = await api.getRequest(
        `api/alarms/charts?licenseType=${license}&networkId=${networkId}`
      );

      if (response?.response) {
        // Transform the data into an array suitable for the chart
        const formattedData = Object.keys(response.response).map(
          (category) => ({
            name: category,
            value: response.response[category].count,
          })
        );
        setAlertsData(formattedData);
      } else {
        console.error("Unexpected API response:", response);
        setAlertsData([]);
      }
    } catch (error) {
      console.error("Error fetching alerts data:", error);
    } finally {
      setChartLoading(false);
    }
  };
  const renderLegend = (props) => {
    const { payload } = props;
    return (
      <ul
        className="custom-legend category"
        style={{
          listStyleType: "none",
          padding: 0,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {payload.map((entry, index) => (
          <li
            key={`item-${index}`}
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: 10,
              marginBottom: 6,
            }}
          >
            <span
              style={{
                display: "inline-block",
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: entry.color,
                marginRight: 6,
              }}
            />
            {entry.value}
          </li>
        ))}
      </ul>
    );
  };

  const fetchAlertTrends = async (networkId) => {
    settrendsLoading(true);
    try {
      const api = new allApi();
      const severity = severityLevels[selectedSeverity];
      const response = await api.getRequest(
        `api/alarms/alertTrends?duration=${selectedInterval}&category=${selectedCategory}&severityLevel=${severity}&networkId=${networkId}`
      );

      if (Array.isArray(response)) {
        const trendsData = response.map((item) => ({
          ...item,
          alert_time: formatAlertTime(item.alert_time), // Make sure this is returning a timestamp!
        }));
        setTrendsData(trendsData);
      } else {
        setTrendsData([]);
      }
    } catch (error) {
      console.error("Error fetching alerts data:", error);
    } finally {
      settrendsLoading(false);
    }
  };

  const formatAlertTime = (alertTime) => {
    // Handle "HH:MM" time format (24-hour)
    if (/^\d{2}:\d{2}$/.test(alertTime)) {
      const today = new Date();
      const [hours, minutes] = alertTime.split(":");
      today.setHours(parseInt(hours, 10));
      today.setMinutes(parseInt(minutes, 10));
      today.setSeconds(0);
      today.setMilliseconds(0);

      return today.getTime(); // Return timestamp for X-Axis plotting
    }

    // Handle "DD-MM-YYYY" date format
    if (/^\d{2}-\d{2}-\d{4}$/.test(alertTime)) {
      const [day, month, year] = alertTime.split("-");
      const formattedDate = new Date(
        parseInt(year, 10),
        parseInt(month, 10) - 1,
        parseInt(day, 10)
      );

      if (isNaN(formattedDate.getTime())) {
        console.error("Invalid alert_time format:", alertTime);
        return null;
      }

      return formattedDate.getTime(); // Return timestamp
    }

    // If format doesn't match, log error and return null
    console.error("Invalid alert_time format:", alertTime);
    return null;
  };

  const handleSearchFilterByName = async (page, name, value) => {
    setLoading(true);
    try {
      const api = new allApi();
      const response = await api.getRequest(
        `api/alarms/all?page=${page}&size=${devicesPerPage}&column=${name}&value=${value}&alarmType=${license}`
      );
      if (!response.items) {
        throw new Error("Failed to fetch filtered alarms");
      }

      setDeviceListings(response.items);
      setFilteredDevices(response.items);
      setTotalPages(response.totalPages || 1);
      setTotalDevices(response.totalItems || 0);
    } catch (error) {
      console.error("Error fetching filtered alarm logs:", error);
      setDeviceListings([]);
      setFilteredDevices([]);
    } finally {
      setLoading(false);
    }
  };

  const debouncedSearch = useCallback(
    debounce((page, name, value) => {
      if (license && value) {
        handleSearchFilterByName(page, name, value);
      }
    }, 500),
    [license]
  );

  const handleTableSearch = (value) => {
    setTableQuery(value);
    const trimmedValue = value.trim();
    if (trimmedValue) {
      setSearchActive(true);
      setSearchColumn("device_name");
      setSearchValue(trimmedValue);
      setCurrentPage(1);
      debouncedSearch(1, "device_name", trimmedValue);
    } else {
      setSearchActive(false);
      setSearchColumn("");
      setSearchValue("");
      fetchAlarmData(networkId, 1);
    }
  };

  const handleSearch = (e) => handleTableSearch(e.target.value);

  const severityClass = (level) => {
    const value = String(level || "").toLowerCase();
    if (value.includes("critical") || value === "1") return "critical";
    if (value.includes("major") || value === "2") return "major";
    if (value.includes("minor") || value === "3") return "minor";
    return "info";
  };

  return (
    <div className="nms-dash alerts-page">
      <div className="col-lg-12">
        <div className="row mb-4">
          <div className="col-lg-5">
            <div className="inc-card">
              <div className="inc-card-title">
                <h3>{localizationStrings?.category}</h3>
              </div>
              <div className="inc-card-body">
                {chartLoading ? (
                  <Loader />
                ) : alertsData.length === 0 ? (
                  <div className="nms-empty">{localizationStrings?.noData || "No Data Found"}</div>
                ) : (
                  <div className="row">
                    <div className="col-lg-6">
                      <ResponsiveContainer width="100%" height={250}>
                        <PieChart>
                          <Pie
                            data={alertsData}
                            cx="50%"
                            cy="50%"
                            innerRadius={70}
                            outerRadius={90}
                            fill="#8884d8"
                            paddingAngle={1}
                            dataKey="value"
                          >
                            {alertsData.map((entry, index) => (
                              <Cell
                                key={`cell-${index}`}
                                fill={COLORS[index % COLORS.length]}
                                cursor="pointer"
                                onClick={() => setSelectedCategory(entry.name)}
                              />
                            ))}
                          </Pie>
                          <Tooltip />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                    <div className="col-lg-6 category-label">
                      <ul>
                        {alertsData.map((entry, index) => (
                          <li key={entry.name}>
                            <i
                              className="fa fa-circle"
                              aria-hidden="true"
                              style={{ color: COLORS[index % COLORS.length] }}
                            />{" "}
                            {entry.name} ({entry.value})
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="inc-card">
              <div className="inc-card-title">
                <h3>{localizationStrings?.alertsSummary}</h3>

                <div className="summary-dropdown">
                  <div>
                    {/* Interval Dropdown */}
                    <span
                      className="dropdown"
                      id="intervalDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span>
                        {selectedInterval}{" "}
                        <i className="fa fa-angle-down" aria-hidden="true"></i>
                      </span>
                      <ul
                        className="dropdown-menu dropdown-menu-end"
                        aria-labelledby="intervalDropdown"
                      >
                        <li>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleIntervalChange("24h");
                            }}
                          >
                            24 {localizationStrings?.hour}
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleIntervalChange("1w");
                            }}
                          >
                            1 {localizationStrings?.week}
                          </a>
                        </li>
                        {license === "Enterprise" && (
                          <>
                            <li>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleIntervalChange("2w");
                                }}
                              >
                                2 {localizationStrings?.week}
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleIntervalChange("1m");
                                }}
                              >
                                {localizationStrings?.monthly}
                              </a>
                            </li>
                          </>
                        )}
                      </ul>
                    </span>
                  </div>
                  <div>
                    <span
                      className="dropdown"
                      id="categoryDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span>
                        {
                          categoryOptions.find(
                            (opt) => opt.key === selectedCategory
                          )?.label
                        }{" "}
                        <i className="fa fa-angle-down" aria-hidden="true"></i>
                      </span>

                      <ul
                        className="dropdown-menu dropdown-menu-end"
                        aria-labelledby="categoryDropdown"
                      >
                        {categoryOptions.map((option) => (
                          <li key={option.key}>
                            <a
                              className="dropdown-item"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleCategoryChange(option.key);
                              }}
                            >
                              {option.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </span>
                  </div>
                  <div>
                    {/* Severity Dropdown */}
                    <span
                      className="dropdown"
                      id="severityDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span>
                        {
                          severityOptions.find(
                            (opt) => opt.key === selectedSeverity
                          )?.label
                        }{" "}
                        <i className="fa fa-angle-down" aria-hidden="true"></i>
                      </span>
                      <ul
                        className="dropdown-menu dropdown-menu-end"
                        aria-labelledby="severityDropdown"
                      >
                        {severityOptions.map((option) => (
                          <li key={option.key}>
                            <a
                              className="dropdown-item"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleSeverityChange(option.key);
                              }}
                            >
                              {option.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </span>
                  </div>
                </div>
              </div>
              <div className="inc-card-body">
                {trendsLoading ? (
                  <Loader />
                ) : trendsData.length === 0 ? (
                  <div className="nms-empty">{localizationStrings?.noData || "No data"}</div>
                ) : (
                  <ResponsiveContainer width="100%" height={250}>
                    <LineChart
                      data={trendsData}
                      margin={{ top: 20, right: 30, left: -20, bottom: 5 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" stroke={chartBorder} />
                      <XAxis
                        dataKey="alert_time"
                        stroke={chartMuted}
                        tick={{ fill: chartMuted, fontSize: 11 }}
                        tickFormatter={(value) => {
                          const date = new Date(value);
                          return selectedInterval === "24h"
                            ? date.toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                              })
                            : date.toLocaleDateString();
                        }}
                      />
                      <YAxis
                        dataKey="alert_count"
                        stroke={chartMuted}
                        tick={{ fill: chartMuted, fontSize: 11 }}
                      />
                      <Tooltip
                        contentStyle={{
                          background: isDark ? "#111827" : "#FFFFFF",
                          border: `1px solid ${chartBorder}`,
                          color: chartTitle,
                        }}
                        labelFormatter={(label) => {
                          const date = new Date(label);
                          return selectedInterval === "24h"
                            ? date.toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: false,
                              })
                            : date.toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                              });
                        }}
                        formatter={(value) => [`${value}`, "Alerts"]}
                      />
                      <Line
                        type="monotone"
                        dataKey="alert_count"
                        stroke="#0284C7"
                        strokeWidth={2}
                        dot={false}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-12">
        <div className="inc-card h-auto">
          <div className="inc-card-title">
            <h3>{localizationStrings?.alertsList}</h3>
            <div className="inc-card-button">
              <NmsTableSearch
                value={tableQuery}
                onChange={handleTableSearch}
                placeholder={localizationStrings?.search || "Search alerts"}
              />
              <button
                className="icon-btn"
                title="Refresh"
                onClick={() => fetchAlarmData(networkId)}
              >
                {refreshing ? (
                  <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                ) : (
                  <i className="fa fa-refresh" aria-hidden="true"></i>
                )}
              </button>

              {/* <button className="icon-btn" title="Download">
                  <i className="fa fa-download" aria-hidden="true"></i>
                </button>
                <button className="icon-btn" title="Filter">
                  <i className="fa fa-filter" aria-hidden="true"></i>
                </button> */}
            </div>
          </div>
          <div className="inc-card-body">
            <div>
              <div className="inc-card-table">
                <table className="full-table m-head">
                  <thead>
                    <tr>
                      <th></th>
                      <th
                        className="inc-th-sort"
                        onClick={() => handleSortChange("device_name")}
                      >
                        {localizationStrings?.deviceName}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className="inc-th-sort"
                        onClick={() => handleSortChange("device_ip")}
                      >
                        {localizationStrings?.ipAddress}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className="inc-th-sort"
                        onClick={() => handleSortChange("severityLevel")}
                      >
                        {localizationStrings?.severityLevel}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className="inc-th-sort"
                        onClick={() => handleSortChange("alarm_behaviour")}
                      >
                        {localizationStrings?.alertsBehaviour}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className="inc-th-sort"
                        onClick={() => handleSortChange("event_name")}
                      >
                        {localizationStrings?.eventName}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className="inc-th-sort"
                        onClick={() => handleSortChange("alarm_time")}
                      >
                        {localizationStrings?.alertsTime}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className="inc-th-sort"
                        onClick={() => handleSortChange("alarm_description")}
                      >
                        {localizationStrings?.alertsDescription}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                    </tr>
                    <tr className="search-border">
                      <td></td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          name="device_name"
                          onKeyUp={(e) => handleSearch(e)}
                        />
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          name="device_ip"
                          onKeyUp={handleSearch}
                        />
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          name="severityLevel"
                          onKeyUp={(e) => handleSearch(e)}
                        />
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          name="alarm_behaviour"
                          onKeyUp={(e) => handleSearch(e)}
                        />
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          name="event_name"
                          onKeyUp={(e) => handleSearch(e)}
                        />
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          name="alarm_time"
                          onKeyUp={(e) => handleSearch(e)}
                        />
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          name="alarm_description"
                          onKeyUp={(e) => handleSearch(e)}
                        />
                      </td>
                    </tr>
                  </thead>
                  {loading ? (
                    <tbody>
                      <tr>
                        <td colSpan="8">
                          <Loader />
                        </td>
                      </tr>
                    </tbody>
                  ) : deviceListings.length === 0 ? (
                    <tbody>
                      <tr>
                        <td colSpan="8">
                          <div className="nms-empty">{localizationStrings?.noData}</div>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      {deviceListings.map((device, index) => (
                        <tr key={index}>
                          <td></td>
                          <td>{device.device_name || "N/A"}</td>
                          <td>{device.device_ip || "N/A"}</td>
                          <td>
                            <span className={`severity-chip ${severityClass(device.severityLevel)}`}>
                              {device.severityLevel || "N/A"}
                            </span>
                          </td>
                          <td>{device.alarm_behaviour || "N/A"}</td>
                          <td>{device.event_name || "N/A"}</td>
                          <td>
                            {device.alarm_time
                              ? moment(device.alarm_time).isValid()
                                ? moment(device.alarm_time).format(
                                    "YYYY-MM-DD HH:mm:ss"
                                  )
                                : device.alarm_time
                              : "N/A"}
                          </td>{" "}
                          <td>{device.alarm_description || "N/A"}</td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
          <div className="pagination-container">
            {totalDevices > 0 ? (
              <>
                <div className="pagination-info">
                  {totalDevices > 0 ? (
                    <p>
                      {localizationStrings?.showing} {indexOfFirstDevice + 1}-
                      {location?.state && location?.state?.severityAlerts
                        ? totalDevices
                        : Math.min(
                            currentPage * devicesPerPage,
                            totalDevices
                          )}{" "}
                      {localizationStrings?.of} {totalDevices}{" "}
                      {localizationStrings?.records}
                    </p>
                  ) : (
                    <p>{localizationStrings?.noRecords}</p>
                  )}
                </div>
                {!location?.state && !location?.state?.severityAlerts && (
                  <div className="pagination">
                    <button
                      onClick={handleFirstPage}
                      disabled={currentPage === 1}
                    >
                      {localizationStrings?.firstPage}
                    </button>
                    <button
                      onClick={handlePrevPage}
                      disabled={currentPage === 1}
                    >
                      {localizationStrings?.previous}
                    </button>
                    {getPageNumbers().map((page) => (
                      <button
                        key={page}
                        onClick={() => handlePageClick(page)}
                        className={currentPage === page ? "active" : ""}
                      >
                        {page}
                      </button>
                    ))}
                    <button
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages}
                    >
                      {localizationStrings?.next}
                    </button>
                    <button
                      onClick={handleLastPage}
                      disabled={currentPage === totalPages}
                    >
                      {localizationStrings?.lastPage}
                    </button>
                  </div>
                )}
              </>
            ) : (
              <div>
                <p>{localizationStrings?.noRecords}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
